import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Technology } from '../models/technology.model';
import { environment } from '../../environments/environment';
import { CheckSimilarResponse } from './systems.service'; // Reutilizamos el contrato

@Injectable({
  providedIn: 'root'
})
export class TechnologyService {

  constructor(private http: HttpClient) {}

  getAllTechnologies(): Observable<Technology[]> {
    return this.http.get<Technology[]>(environment.api_service_technology);
  }

  getTechnologyById(id: string): Observable<Technology> {
    return this.http.get<Technology>(`${environment.api_service_technology}/${id}`);
  }

  createTechnology(technology: Technology): Observable<Technology> {
    return this.http.post<Technology>(environment.api_service_technology, technology);
  }

  updateTechnology(id: string, technology: Technology): Observable<Technology> {
    return this.http.put<Technology>(`${environment.api_service_technology}/${id}`, technology);
  }

  deleteTechnology(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.api_service_technology}/${id}`);
  }

  // 1c: invoca el endpoint de detección de similitud, simétrico a SystemService.
  checkSimilar(name: string, excludeId?: string | null): Observable<CheckSimilarResponse> {
    return this.http.post<CheckSimilarResponse>(
      `${environment.api_service_technology}/check-similar`,
      { name, excludeId: excludeId || null }
    );
  }
}